import { spacings } from '@constants/theme/spacing.config';
import styled from '@emotion/styled';
import { Button } from 'antd';

export const SadaKTimeButton = styled(Button)`
  margin: ${spacings.xxs} 0;
`;
